import * as React from 'react'
import { SVGProps } from 'react'
const SvgPin2 = (props: SVGProps<SVGSVGElement>) => (
  <svg width={12} height={18} viewBox="0 0 12 18" fill="none" {...props}>
    <path
      d="M6 13.975c1.637-1.436 2.88-2.828 3.728-4.177C10.576 8.449 11 7.188 11 6.016c0-1.475-.467-2.68-1.4-3.614C8.667 1.467 7.467 1 6 1s-2.667.467-3.6 1.402C1.467 3.336 1 4.541 1 6.016c0 1.173.424 2.433 1.272 3.782.848 1.349 2.09 2.741 3.728 4.177Zm0 1.275c-1.978-1.618-3.473-3.208-4.484-4.771C.506 8.916 0 7.429 0 6.016c0-1.763.56-3.207 1.68-4.33C2.802.562 4.242 0 6 0c1.759 0 3.199.562 4.32 1.685C11.44 2.81 12 4.253 12 6.016c0 1.413-.505 2.898-1.516 4.454C9.473 12.026 7.978 13.62 6 15.25Zm0-7.635c.447 0 .829-.157 1.143-.472.315-.314.473-.696.473-1.143 0-.447-.158-.829-.473-1.143A1.557 1.557 0 0 0 6 4.384c-.447 0-.829.158-1.143.473A1.557 1.557 0 0 0 4.384 6c0 .447.158.829.473 1.143.314.315.696.473 1.143.473ZM0 18v-1h12v1H0Z"
      fill="#1C1915"
    />
  </svg>
)
export default SvgPin2
